
import i18n from "@/i18n";
import store from "@/store";
import { Third } from "@/types";
import { addExpandedItem, getMaskFormat, getMaskInput, isCustomerApeNotEligible, OFFER_TAX, removeExpandedItem } from "@/utils";
import { formatDateLocale, getSirenMask } from "@/utils/configuration/formatters-config";
import { Options, Vue } from "vue-class-component";
import { useRoute } from "vue-router";
import {currencyConfiguration} from "@/utils/configuration/currencyInput-config";
import twCurrencyInput from "@/components/general/twCurrencyInput.vue";
import PartyFinancialSituation from "@/components/middle-office/tabs/party/organization/PartyFinancialSituation.vue";
import TaskPartyClassification from "@/components/middle-office/tabs/party/TaskPartyClassification.vue";
import PartyContact from "@/components/middle-office/tabs/party/organization/PartyContact.vue";
import { checkOrganization } from "@/store/services/offerService";
@Options({
  props: ["party","expansionInitially","tabPosition"],
  components:{
    twCurrencyInput,
    PartyFinancialSituation,
    TaskPartyClassification,
    PartyContact
  },
  computed:{
    isPartyOrganizationEligible:function(){
      return isCustomerApeNotEligible(this.offer)
    }
  },
  watch:{
     "party.organization.activitySector.type.value"(newValue) {
    const selected = this.activitySector.find((o: any) => o.value === newValue);
    if (selected) {
      this.party.organization.activitySector.flagEligible = selected.flagEligible;
    } else {
      this.party.organization.activitySector.flagEligible = null;
    }
  },
  legalCategory(options: any[]) {
    this.filteredLegalCategoryOptions = options;
  },
  }
})
export default class PartyProDetails extends Vue {
  party?: Third;
  tabPosition?: number;
  expansionInitially?: boolean;
  managedOrganizationOpened?:boolean = false;
  financialExposures: any[] = [];
  maskInput = getMaskInput();
  maskFormat = getMaskFormat();
  managerOpened = true;
  identityOpened = false;
  ExpossureBtn = true;
  ExpossureItemPlusBtn = false;
  addExpandedItem = addExpandedItem;
  removeExpandedItem = removeExpandedItem;
  dateMask = "DD/MM/YYYY";
  filteredLegalCategoryOptions: any[] = [];

created(){
    this.managedOrganizationOpened = this.expansionInitially;
}

mounted() {
  this.filteredLegalCategoryOptions = this.legalCategory;
}
get isMO() {
    if (this.currentRoute !== 'TaskDetail') {
      return true
    } else
      return false
  }
  get offer() {
    return store.state.demandModule.offer || store.state.middleOfficeModule.offer;
  }
  get currentRoute() {
    return useRoute().name;
  }
  get  isExposureBtnDisabled () {
      return !this.ExpossureBtn;
    }
  get manager() {
    if (this.offer?.resourceUid && this.party?.organization?.manager) {
      this.party.organization.manager.show = false;
    }
    return this.party?.organization?.manager;
  }
  get FR() {
    return {
      days: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi",
      ],
      daysShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
      months: [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
      ],
      monthsShort: [
        "janv",
        "févr",
        "mars",
        "avr",
        "mai",
        "juin",
        "juil",
        "août",
        "sept",
        "oct",
        "nov",
        "déc",
      ],
    };
  }
  get expossureList() {
    return this.party?.organization?.financialExposures;
  }
  get exposuresList() {
    return this.expossureList?.filter(
      (exposure:any) => exposure.contractReference === this.offer?.reference
    );
  }
    get naceOptions() {
    return store.getters["picklistModule/codeNaceOptionsItems"]
      ?.map((item: any) => {
        return {
          ...item,
          label:
            item.value?.toString() !== ""
              ? `${item.value} - ${i18n.global.t(
                "picklists.codeNace.".concat(item.value)
              )}`
              : "",
        };
      })
      .sort((a: any, b: any) => a.label.localeCompare(b.label));
  }
    get activitySector() {
    return store.getters["picklistModule/activitySectorItems"].map((item: any) => {
      return {
        ...item,
        label:
          item.value?.toString() !== ""
            ? `${item.value} - ${i18n.global.t(
              "picklists.activity.".concat(item.value)
            )}`
            : "",
      };
    });
  }
    get legalCategory() {
    return store.getters["picklistModule/legalCategoryItems"].map((item: any) => {
      return {
        ...item,
        label:
          item.value?.toString() !== ""
            ? `${item.value} - ${i18n.global.t(
              `picklists.legal-category.${item.value}`
            )}`
            : "",
      };
    });
  }

  filterPicklistByCodeOrLabel(
    val: string,
    update: (fn: () => void) => void,
    source: any[],
    assign: (options: any[]) => void
  ) {
    update(() => {
      if (!val) {
        assign(source);
        return;
      }
      const needle = val.toLowerCase().trim();
      assign(
        source.filter((item: any) => {
          const code = (item.value ?? "").toString().toLowerCase();
          const label = (item.label ?? "").toLowerCase();
          return code.includes(needle) || label.includes(needle);
        })
      );
    });
  }

  filterLegalCategory(val: string, update: (fn: () => void) => void) {
    this.filterPicklistByCodeOrLabel(
      val,
      update,
      this.legalCategory,
      (options: any[]) => {
        this.filteredLegalCategoryOptions = options;
      }
    );
  }

  get currencyConfiguration() {
    return currencyConfiguration;
  }
  getSirenMask(locale?: string) {
    return getSirenMask(locale);
  }

  removeExpanded(exposureToRemove: any) {
    const index = this.expossureList?.findIndex((e) => e === exposureToRemove);
    if (index !== undefined && index !== -1) {
      this.expossureList?.splice(index, 1);
    }
  }
  calculateExposureGrossOutstanding(index: number, netOutstanding: any): any | undefined {
    if (netOutstanding) {
      
      const isOrganisation = checkOrganization(this.party?.type);
      if(isOrganisation && this.party && this.party.organization){
        this.party.organization.financialExposures![index].grossOutstanding = String(netOutstanding * OFFER_TAX);
        return this.party.organization.financialExposures![index].grossOutstanding;
      }
      else if(!isOrganisation && this.party && this.party.person){
        this.party.person.financialExposures![index].grossOutstanding = String(netOutstanding * OFFER_TAX);
        return this.party.person.financialExposures![index].grossOutstanding;
      }
    }
  }
  addExpandedExpossure(items: any[]) {
    if (!!items && items.length === 0) {
      const element = store.getters["thirdModule/getExpossureInit"];
      element.contractReference = this.offer?.reference;
      this.expossureList?.push(element);
    }
  }

  addExpossure() {
    const element = store.getters["thirdModule/getExpossureInit"];
    element.contractReference = this.offer?.reference;
    this.expossureList?.push(element);
  }

  onFinancialInstitutionChange(exposure: any, financialInstitutionValue: string) {
    if (financialInstitutionValue !== "CF" && financialInstitutionValue !== "AFF_LIEE") {
      return;
    }
    if (!exposure.outstandingType) {
      exposure.outstandingType = { value: "", label: "" };
    }
    exposure.outstandingType.value = "OTHER";
  }
  get typeOutstanding() {
    return store.getters["picklistModule/typeOutstandingItems"]
      ?.map((item: any) => {
        return {
          ...item,
          label:
            item.value?.toString() !== ""
              ? i18n.global.t(
                "middleOffice.party.organization.typeOutstanding." +
                item.value
              )
              : "",
        };
      })
      .sort((a: any, b: any) => a.label.localeCompare(b.label));
  }

  get financialInstitution() {
    return store.getters["picklistModule/financialInstitutionItems"]
      ?.map((item: any) => {
        return {
          ...item,
          label:
            item.value?.toString() !== ""
              ? i18n.global.t(
                "middleOffice.party.organization.financialInstitution." +
                item.value
              )
              : "",
        };
      })
      .sort((a: any, b: any) => a.label.localeCompare(b.label));
  }

  verifyKSIOPCombination(
    financialInstitution: string,
    outstandingType: string
  ) {
    if (financialInstitution !== "KSIOP") {
      return true;
    } else if (outstandingType === "AXA") {
      return false;
    }
    return true;
  }
  get associatedPartyIndex(){
    return this.offer?.associatedParties?.findIndex((associatedParty:any) => associatedParty.associatedParty.resourceUid === this.party?.resourceUid)
  }
  onChangeFlagFinancialPool(value: any, event: any) {
    if (!event.target) {
      value.shareFinancialPool = null;
    }
  }

  onChangeFlagRiskPool(value: any, event: any) {
    if (!event.target) {
      value.shareRiskPool = null;
    }
  }
  recalculateKSIOP(value: any, index: number) {
    store.dispatch("demandModule/recalculateKSIOP", {
      associatedPartyIndex: this.associatedPartyIndex,
      financial: value,
      currency: this.currencyConfiguration.currency,
      callback: (result: any) => {
          this.party?.organization?.financialExposures ? this.party.organization.financialExposures[index].businessData = result.businessData : ''
      },
    });
  }
  formatDateFrom(value: any) {
    value.validity.from = value.validity.from.includes("/")
      ? formatDateLocale(value.validity.from, "DD/MM/YYYY", "fr", "DD/MM/YYYY")
      : formatDateLocale(value.validity.from, "DDMMYYYY", "fr", "DD/MM/YYYY");
  }
  formatDateUntil(value: any) {
    value.validity.until = value.validity.until.includes("/")
      ? formatDateLocale(value.validity.until, "DD/MM/YYYY", "fr", "DD/MM/YYYY")
      : formatDateLocale(value.validity.until, "DDMMYYYY", "fr", "DD/MM/YYYY");
  }

  formatDate(date: string) {
    return formatDateLocale(date, this.dateMask, "fr", "YYYY/MM/DD");
  }
}
